import React from "react";
import RecognitionPage from "../shared/recognition/RecognitionPage";
import useRecognitionApi from "../shared/recognition/useRecognitionApi";

const EXPENSE_CONFIG = {
  periodBy: "contract",
  themeClass: "rr-theme--expense",
  documentPrefix: "ПР",
  entry: {
    debit: "Расходы будущих периодов",
    credit: "Кредиторская задолженность",
  },
  texts: {
    noun: "Расходы",
    nounGenitive: "расходов",
    settingsTab: "Настройки договоров",
    totalLabel: "Итого расходов за период",
    detailsCaption: "Признание расходов",
    formTitle: "Создание признания расходов",
    calcTitle: "Расчет расходов",
    submit: "Признать расходы",
    confirmTitle: "Признать расходы?",
    toastTitle: "Расходы признаны",
    note:
      "После подтверждения система сформирует управленческую операцию признания расходов и отразит её в Журнале операций.",
  },
};

function ExpenseRecognition() {
  const remote = useRecognitionApi("expense");
  if (!remote.data) {
    return <div className="rr">{remote.error || "Загрузка признания расходов..."}</div>;
  }
  return (
    <RecognitionPage
      config={EXPENSE_CONFIG}
      data={remote.data}
      initialRecognitions={remote.recognitions}
      initialSettings={remote.settings}
      remote={remote}
    />
  );
}

export default ExpenseRecognition;
